module.exports = "<h2 mat-dialog-title>{{titolo}}</h2>\n<div mat-dialog-content>\n\t<p>{{messaggio}}</p>\n</div>\n<div mat-dialog-actions>\n\t<button mat-button mat-dialog-close class=\"btn btn-primary\">Ok</button>\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/components/utilita/dialogs/dialog-notifica/dialog-notifica.component.html
// module id = ../../../../../src/app/components/utilita/dialogs/dialog-notifica/dialog-notifica.component.html
// module chunks = main